import CarouselDailyItem from "./CarouselDailyItem";

export default CarouselDailyItem;
